import { render } from "./AlertsNotificationBadge.vue?vue&type=template&id=bdb1e5e0&scoped=true"
import script from "./AlertsNotificationBadge.vue?vue&type=script&lang=js"
export * from "./AlertsNotificationBadge.vue?vue&type=script&lang=js"

import "./AlertsNotificationBadge.vue?vue&type=style&index=0&id=bdb1e5e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb1e5e0"]])

export default __exports__